module.exports = __webpack_public_path__ + "static/media/startTimerFilled.e2d6413e.svg";